import { Box, Chip, Stack, Typography } from "@mui/material";
import { AccessTime, CheckCircleOutline } from "@mui/icons-material";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import { useGetTasksQuery } from "../../services/tasks.service";
import { useAppTheme } from "../../context/ThemeContext";
import moment from "moment";

function DueTodayBanner() {
  const { data: tasks } = useGetTasksQuery("Tasks");
  const currentUserId = useSelector((state: RootState) => state.user._id);
  const { accentColor } = useAppTheme();

  const today = moment().startOf("day");

  const dueToday = (tasks ?? []).filter((t) => {
    if (t.status === "Completed") return false;
    if (!t.dueDate) return false;
    return moment(t.dueDate as any).isSame(today, "day");
  });

  const mine = dueToday.filter((t) => t.assignedTo === currentUserId);
  const others = dueToday.filter((t) => t.assignedTo !== currentUserId);

  if (dueToday.length === 0) return null;

  return (
    <Box
      sx={{
        mb: 2.5,
        px: 2,
        py: 1.25,
        borderRadius: "8px",
        bgcolor: "#FFFBEB",
        border: "1px solid #FDE68A",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        flexWrap: "wrap",
        gap: 1,
      }}
    >
      <Stack direction="row" alignItems="center" spacing={1.25}>
        <AccessTime sx={{ color: "#D97706", fontSize: 18 }} />
        <Typography variant="body2" fontWeight={700} color="#92400E">
          {dueToday.length} task{dueToday.length !== 1 ? "s" : ""} due today
          {mine.length > 0 && (
            <Typography component="span" variant="body2" color="#D97706" fontWeight={400}>
              {" "}({mine.length} assigned to you)
            </Typography>
          )}
        </Typography>
      </Stack>

      <Stack direction="row" spacing={0.75} flexWrap="wrap">
        {dueToday.slice(0, 4).map((t) => (
          <Chip
            key={t._id}
            label={t.name}
            size="small"
            variant={t.assignedTo === currentUserId ? "filled" : "outlined"}
            sx={{
              fontSize: "0.72rem",
              borderRadius: "4px",
              height: 22,
              fontWeight: t.assignedTo === currentUserId ? 700 : 400,
              bgcolor: t.assignedTo === currentUserId ? "#FDE68A" : "transparent",
              borderColor: "#FCD34D",
              color: "#92400E",
            }}
          />
        ))}
        {dueToday.length > 4 && (
          <Chip
            label={`+${dueToday.length - 4} more`}
            size="small"
            sx={{ fontSize: "0.72rem", borderRadius: "4px", height: 22, color: "#92400E", borderColor: "#FCD34D" }}
            variant="outlined"
          />
        )}
      </Stack>
    </Box>
  );
}

export default DueTodayBanner;
